import { bootstrapApplication } from "@angular/platform-browser";
import { enableProdMode } from "@angular/core";
import { SignupAppComponent, SignupConfig } from "./signupApp";

declare let document: any; // there is no document on mobile

// Enable production mode unless running locally
if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

bootstrapApplication(SignupAppComponent, SignupConfig);
